export default theme => ({
  root: {
    display: "flex",
    flexDirection: "row",
    height: "100vh",
    overflow: "hidden",
  },
  drawerPaper: {
    width: "270px",
    height: "100%",
    backgroundColor: "#1c1c22",
  },
  sidebar: {
    width: "270px",
  },
  content: {
    flex: 1,
    minHeight: "100vh",
    overflow: "auto",
    backgroundColor: theme.palette.background.default,
  },
  contentWrapper: {
    padding: 0,
  },
});
